<div class="modal-header">
  <h4 class="modal-title" i18n>Share</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <h4 i18n>Earn referral discounts</h4>
  <p i18n>For every 3 friends that sign up, make and pay an order you earn 5% referral discount that you can use with your future orders.</p>
  <button type="button" class="btn btn-primary w-100" (click)="share()" i18n>Share</button>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>